<template>
	<div class="page">
		<div class="page__top-bar" style="background-color: white;">
			<div class="page__title"><svg-icon @click="toggleMobileMenu" class="icon" icon="menu" />{{ title }}</div>
			<div class="page__tools">
				<slot name="tools" />
			</div>
		</div>
		<div class="page__content">
			<slot />
		</div>
	</div>
</template>

<script>
	import { bus } from './../bus';

	export default {
		props: ['title'],
		methods: {
			toggleMobileMenu() {
				bus.$emit('mobile-menu-toggle');
			}
		}
	}
</script>

<style lang="scss">
	.page {
		&__top-bar {
			position: absolute;
			left: 0;
			top: 0;
			height: 81px;
			width: 100%;
			border-bottom: 1px solid #cecece;
		}

		&__title {
			font-size: 24px;
			padding-left: 30px;
			line-height: 80px;
			display: inline-block;

			& > .icon {
				position: absolute;
				left: 20px;
				top: 28px;
				display: none;
				width: 24px;
				height: 24px;
			}
		}

		&__tools {
			position: absolute;
			top: 0;
			right: 0;
			height: 80px;
			padding: 20px 20px 20px;
			
			& > * {
				float: left;
				margin-left: 20px;
			}
		}

		&__content {
			position: absolute;
			left: 0;
			top: 81px;
			bottom: 0;
			width: 100%;
			overflow: auto;
			-webkit-overflow-scrolling: touch;
		}
	}

	@media only screen and (max-width: 600px ) {
		.page__top-bar {
			height: 81px;
		}

		.page__title {
			padding-left: 60px;
			line-height: 80px;
			font-size: 18px;

			& > .icon {
				display: block;
			}
		}
	}

	
</style>